import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTranslation } from 'react-i18next';

const SuccessDialog = ({ open, onClose, onViewComplaints, submissionDate }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        style: {
          borderRadius: '16px', 
          boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)' 
        }
      }}
    >
      <DialogTitle
        sx={{
          fontSize: '1.6rem',
          fontWeight: 'bold',
          color: '#4caf50',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}
      >
        <CheckCircleIcon fontSize="large" sx={{ color: '#4caf50' }} />
        {t('dialog.successTitle')}
      </DialogTitle>
      <DialogContent>
        <Typography
          variant="body1"
          gutterBottom
          sx={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}
        >
          {t('dialog.successMessage')}
        </Typography>
        {submissionDate && (
          <Typography
            variant="body2"
            sx={{ color: 'text.secondary', marginTop: '8px' }}
          >
            {t('dialog.dateLabel')}: {submissionDate}
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ padding: '16px' }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: '#1976d2', 
            color: 'white',
            padding: '10px 20px',
            borderRadius: '8px',
            boxShadow: '0px 4px 10px rgba(25, 118, 210, 0.2)', 
            '&:hover': {
              backgroundColor: '#1565c0'
            },
            transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
            margin: '0 10px'
          }}
        >
          {t('dialog.okButton')}
        </Button>
        <Button
          onClick={onViewComplaints}
          variant="outlined"
          sx={{
            borderColor: '#4caf50',
            color: '#4caf50',
            padding: '10px 20px',
            borderRadius: '8px',
            '&:hover': {
              backgroundColor: 'rgba(76, 175, 80, 0.1)'
            },
            transition: 'background-color 0.3s ease, border-color 0.3s ease',
            margin: '0 10px'
          }}
        >
          {t('dialog.viewComplaintsButton')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;
